import { useState } from 'react'

import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Dialog, DialogContent, IconButton, Table, TableBody, TableCell, TableRow, Tooltip } from '@mui/material'

import { FplDialogTitle } from 'components/common'

const statusDescriptions: Array<{ status: string; meaning: string }> = [
  { status: 'Scheduled', meaning: 'The attempt is scheduled and waiting to run.' },
  {
    status: 'Sent',
    meaning: 'The attempt has been sent to the external calling service and is awaiting a result.',
  },
  {
    status: 'Received',
    meaning:
      'The driver answered and interacted with the agent. This does not necessarily mean the scheduler requirement was fulfilled.',
  },
  { status: 'Ignored', meaning: 'The call was declined or was not answered.' },
  { status: 'Failed', meaning: 'The attempt could not be completed because of an error.' },
  { status: 'Skipped', meaning: 'The attempt was deliberately skipped by scheduler logic.' },
  { status: 'Cancelled', meaning: 'The scheduled attempt was cancelled before it could run.' },
]

const BookingSchedulerControlsStatusLegend = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Tooltip title='Status legend'>
        <IconButton size='small' onClick={() => setOpen(true)}>
          <HelpOutlineIcon fontSize='small' />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth='md'>
        <FplDialogTitle id='scheduler-status-legend-dialog' onClose={() => setOpen(false)}>
          Status Legend
        </FplDialogTitle>
        <DialogContent>
          <Table size='small'>
            <TableBody>
              {statusDescriptions.map(({ status, meaning }) => (
                <TableRow key={status}>
                  <TableCell sx={{ fontWeight: 600, verticalAlign: 'top' }}>{status}</TableCell>
                  <TableCell>{meaning}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default BookingSchedulerControlsStatusLegend
